// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyDNEBq46DZF4YDxayfsSQh-NQai_IW-IUw",
  authDomain: "iotday-evento.firebaseapp.com",
  databaseURL: "https://iotday-evento.firebaseio.com",
  projectId: "iotday-evento",
  storageBucket: "iotday-evento.appspot.com",
  messagingSenderId: "172144689782",
  appId: "1:172144689782:web:fe53f0da633cdc5f791557",
  measurementId: "G-5896C7WP8S"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/iotday-evento.appspot.com/o/'